import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LinkBody from '~/components/LinkBody';
import { signupActions } from '~/services/signup';
import { useMount } from '~/services/utils/hooks';
import LandingTemplate from '~/templates/LandingV2';
import { Translation, useTranslation } from '~/components/Translation';
import usePageTrack from '~/services/analytics/usePageTrack';
import analytics from '~/services/analytics';

const PartnerLandingTemplate = ({
	image,
	name,
	preTitle,
	preTitleKey,
	partner,
	partnerClick,
	partnerDescription,
	partnerDescriptionKey,
	partnerNameKey,
}) => {
	const partnersDescription = useTranslation('landing.partners.description', {
		name,
	});

	usePageTrack({
		name: analytics.events.PARTNER,
		category: analytics.events.category.MARKETING,
		partnerName: name,
	});

	// Save that user signed up through this page
	useMount(() => {
		partnerClick({ partner, referrerType: 'partner' });
	});

	return (
		<LandingTemplate
			preTitle={preTitleKey ? <Translation tid={preTitleKey} /> : preTitle}
			heading={<Translation tid="landing.title" />}
			recommendedBy={{
				image,
				text: partnerDescriptionKey ? (
					<Translation
						tid={partnerDescriptionKey}
						components={{
							link: <LinkBody to="/contact" />,
							name: <Translation tid={partnerNameKey} />,
						}}
					/>
				) : (
					partnerDescription || partnersDescription
				),
			}}
			subHeading={<Translation tid="landing.subtitle.v2" />}
		/>
	);
};

PartnerLandingTemplate.propTypes = {
	image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	name: PropTypes.string.isRequired,
	preTitle: PropTypes.node,
	preTitleKey: PropTypes.string,
	partner: PropTypes.string.isRequired,
	partnerClick: PropTypes.func.isRequired,
	partnerDescription: PropTypes.node,
	partnerDescriptionKey: PropTypes.string,
	partnerNameKey: PropTypes.string,
};

const mapDispatchToProps = {
	partnerClick: signupActions.partnerClick,
};

export default connect(null, mapDispatchToProps)(PartnerLandingTemplate);
